import React, { useState } from "react";
import formatDate from "../../common/Formatdate";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Pencil, PencilIcon, Trash } from "lucide-react";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useSelector } from "react-redux";
import ImagePreviewLoop from "../../common/imagepreviewloop";
import moment from "moment";
import toast from "react-hot-toast";
import ConfirmationModal from "../../common/Confirmationmodal";

const WorkOrderSummary = ({
  workOrderDetail,
  workorderType,
  helpdeskTicketPriority,
  setCreationType,
  setTasks,
  vehicleTaskDetails,
  setActiveTab,
  vehicleServicePartDetails,
  taggedBookings,
  // handleImageOpen,
  paymentDetails,
  billingDetails,
  setPartService,
  workOrderDetailBlock,
  blockedVehicleExtensionData,
  getVehicleServicePartDetails,
  taggedVendors,
  vendorDetails,
  getVehicleTaskDetails,
  serviceLabourCost,
  setLabours,
  getServiceLabourDetails,
  workorderTypeValues,
  getWorkOrderDetails,
}) => {
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const vendorTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vendorTypes;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const isSystemUserDataList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState({ id: null, type: "" });
  const [isEdit, setIsEdit] = useState(false);
  const [workOrderTypesFilter, setWorkOrderTypesFilter] = useState("");

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  const handleImageOpen = (img, idx = 0, imagesArray = []) => {
    setImageSelection(getImageUrl(img));
    setCurrentIndex(idx);
    setCurrentImages(imagesArray);
    setOpenImage(true);
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  const data = {
    workOrder: workOrderDetail?.serviceCode || "-",
    vehicle: workOrderDetail?.licensePlate || "-",
    vehicleImage: workOrderDetail?.vehicleInfo?.imageUrl || null,
    vehicleName: workOrderDetail?.vehicleInfo?.name || "-",
    vehicleGroupText: workOrderDetail?.vehicleInfo?.vehicleGroupText || "-",
    status: workorderStatus[workOrderDetail?.serviceStatus] || "-",
    city: cities[workOrderDetail?.cityId] || "-",
    // issuedBy: workOrderDetail?.issuedByDetails?.name || "-",
    // assignedTo: workOrderDetail?.assignedTo || "-",
    createdAt: formatDateAndTime(workOrderDetail?.createdAt) || "-",
    createdBy:
      isSystemUserDataList?.filter(
        (user) => user?.id === workOrderDetail?.createdBy,
      )[0]?.name || "-",
    // expectedCompletion: workOrderDetail?.expectedCompletion || "-",
    // vendor: workOrderDetail?.vendor || "-",
    // scheduledStartDate: formatDate(workOrderDetail?.scheduledStartDate) || "-",
    // reportedOn: formatDate(workOrderDetail?.reportedOn) || "-",
    odometerReading: workOrderDetail?.odometerReading || "-",
    endingOdometer: workOrderDetail?.endingOdometer,
    endingOdometerImage: workOrderDetail?.endingOdometerImage,
    // priorityId: helpdeskTicketPriority[workOrderDetail?.priorityId] || "-",
    workorderType: workorderType[workOrderDetail?.serviceType] || "-",
    odometerImages: parseImages(workOrderDetail?.odometerImage),
    otherAttachments: parseImages(workOrderDetail?.attachments),
    isPaymentPending: workOrderDetail?.isPaymentPending,
    billingAmount: billingDetails?.billingAmount || 0,
    blockStartDate: formatDateAndTime(workOrderDetailBlock?.startDate),
    blockEndDate: formatDateAndTime(workOrderDetailBlock?.endDate),
    blockedBy: workOrderDetailBlock?.blockedBy,
    startDate: formatDateAndTime(workOrderDetail?.startDate),
    endDate: formatDateAndTime(workOrderDetail?.endDate),
    costToCompany: billingDetails?.costToCompany || 0,
    // jobList: workOrderDetail?.jobList || [],
  };

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const partsAggregate = vehicleServicePartDetails?.reduce(
    (acc, row) => {
      acc.total += Number(row.totalCost || 0);
      acc.labor += Number(row.laborCost || 0);
      acc.discount += Number(row.discountAmount || 0);
      acc.tax += Number(row.totalTax || 0);
      acc.unitPrice += Number(row.unitPrice);
      return acc;
    },
    { total: 0, labor: 0, discount: 0, tax: 0, unitPrice: 0 },
  ) || { total: 0, labor: 0, discount: 0, tax: 0, unitPrice: 0 };

  const tasksAggregate = vehicleTaskDetails?.reduce(
    (acc, row) => {
      const rowTotal = Number(row.totalCost || 0);
      acc.total += rowTotal;
      acc.labor += Number(row.laborCost || 0);
      acc.discount += Number(row.discountAmount || 0);
      acc.tax += Number(row.totalTax || 0);
      acc.totalCost += Number(row.totalCost - row.totalTax || 0);
      return acc;
    },
    { total: 0, labor: 0, discount: 0, tax: 0, totalCost: 0 },
  ) || { total: 0, labor: 0, discount: 0, tax: 0, totalCost: 0 };

  const labourAggregate = serviceLabourCost?.reduce(
    (acc, row) => {
      acc.total += Number(row.totalAmount || 0);
      acc.labor += Number(row.serviceAmount || 0);
      acc.discount += Number(row.discountAmount || 0);
      acc.tax +=
        Number(row.totalTaxAmount || 0) || Number(row?.totalTaxAmount || 0);
      return acc;
    },
    { total: 0, labor: 0, discount: 0, tax: 0 },
  ) || { total: 0, labor: 0, discount: 0, tax: 0 };

  const combinedTotal =
    Number(partsAggregate.total || 0) +
    Number(tasksAggregate.total || 0) +
    Number(labourAggregate.total || 0);

  const roundedTotal = Math.round(Number(combinedTotal || 0));

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

  const getAttachmentUrls = (attachments) => {
    if (!attachments) return [];

    let parsed = [];
    try {
      parsed = JSON.parse(attachments); // parse JSON string
    } catch {
      return [];
    }

    if (!Array.isArray(parsed)) parsed = [parsed];

    return parsed.map((att) => att.Location || att.path || att.url);
  };

  const taggedVendorIds = new Set(
    (taggedVendors || []).map((tv) => tv?.vendorId),
  );
  const taggedVendorDetails = (vendorDetails || []).filter((v) =>
    taggedVendorIds.has(v.id),
  );

  const handleDeleteServiceparts = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/vehicleserviceparts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: deleteId?.id,
          isArchived: true,
        }),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Vehicle Service Part Deleted Successfully 🎉");
        setConfirmModal(false);
        setDeleteId({ id: null, type: "" });
        // setActiveTab("summary");
        await getVehicleServicePartDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleSaveTheWorkOrder = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/vehicleservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: workOrderDetail?.id,
          serviceType: workOrderTypesFilter,
        }),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Service Work Order Type Successfully 🎉");
        setIsEdit(false);
        setWorkOrderTypesFilter(null);
        await getWorkOrderDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleDeleteServiceTasks = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/vehicleservicetasks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: deleteId?.id,
          isArchived: true,
        }),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Vehicle Service Tasks Deleted Successfully 🎉");
        setConfirmModal(false);
        setDeleteId({ id: null, type: "" });
        // setActiveTab("summary");
        await getVehicleTaskDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleDeleteServiceLaboursHistory = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/laborservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: deleteId?.id,
          isArchived: true,
        }),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Vehicle Service Tasks Deleted Successfully 🎉");
        setConfirmModal(false);
        setDeleteId({ id: null, type: "" });
        // setActiveTab("summary");
        await getServiceLabourDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const validation = [    
    Number(workorderStatus?.inverted?.serviceCompleted),
    Number(workorderStatus?.inverted?.enrouteToHub),   
    Number(workorderStatus?.inverted?.billingApproved),    
  ].includes(Number(workOrderDetail?.serviceStatus));

  return (
    <>
      {openImage && (
        <ImagePreviewLoop
          imageSelection={imageSelection}
          openImage={openImage}
          setImageSelection={setImageSelection}
          setOpenImage={setOpenImage}
          setCurrentIndex={setCurrentIndex}
          setCurrentImages={setCurrentImages}
          currentIndex={currentIndex}
          currentImages={currentImages}
        />
      )}

      {confirmModal && (
        <ConfirmationModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          message={
            deleteId?.type === "parts"
              ? {
                  title: "Confirm Deletion",
                  content:
                    "Are you sure you want to delete this vehicle service part?",
                }
              : deleteId?.type === "labour"
                ? {
                    title: "Confirm Deletion",
                    content:
                      "Are you sure you want to delete this vehicle service labour?",
                  }
                : deleteId?.type === "tasks" && {
                    title: "Confirm Deletion",
                    content:
                      "Are you sure you want to delete this vehicle service task?",
                  }
          }
          handleConfirm={
            deleteId?.type === "parts"
              ? handleDeleteServiceparts
              : deleteId?.type === "labour"
                ? handleDeleteServiceLaboursHistory
                : deleteId?.type === "tasks" && handleDeleteServiceTasks
          }
        />
      )}

      <div className="bg-gray-100 min-h-screen">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6 bg-white shadow-lg rounded-2xl p-6 h-full">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
              <div>
                <h2 className="text-md font-bold text-gray-800">
                  {data.workOrder}
                </h2>
              </div>

              {paymentDetails &&
              paymentDetails[0]?.paymentType === "partial" ? (
                <span className="px-3 py-1 text-sm rounded-full bg-yellow-100 text-yellow-700 font-medium">
                  Partial Payment Done
                </span>
              ) : paymentDetails &&
                paymentDetails[0]?.paymentType === "full" ? (
                // &&
                // data?.status === "Service Completed"
                <span className="px-3 py-1 text-sm rounded-full bg-green-100 text-green-700 font-medium">
                  Payment Completed
                </span>
              ) : (
                <span className="px-3 py-1 text-sm rounded-full bg-yellow-100 text-yellow-700 font-medium">
                  Payment Pending
                </span>
              )}

              <span className="font-medium bg-red-100 text-red-700 px-2 py-1 rounded-full">
                Outstanding Balance : ₹
                {(
                  Number(billingDetails?.costToCompany || 0) -
                  paymentDetails?.reduce(
                    (sum, item) => sum + Number(item?.paymentAmount || 0),
                    0,
                  )
                ).toFixed(2)}
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              <div>
                <img alt="img"
                  src={data.vehicleImage}
                  className="w-28 h-12 object-cover rounded-lg"
                />
              </div>

              <div>
                <p className="text-gray-500">Name</p>
                <p className="font-medium text-gray-800">{data.vehicleName}</p>
              </div>

              <div>
                <p className="text-gray-500">Vehicle</p>
                <p className="font-medium text-gray-800">{data.vehicle}</p>
              </div>

              <div>
                <p className="text-gray-500">Group</p>
                <p className="font-medium text-gray-800">
                  {data.vehicleGroupText}
                </p>
              </div>

              <div>
                <p className="text-gray-500">City</p>
                <p className="font-medium text-gray-800">{data.city}</p>
              </div>

              {/* <div>
              <p className="text-gray-500">Vendor</p>
              <p className="font-medium text-gray-800">{data.vendor}</p>
            </div> */}

              {/* <div>
              <p className="text-gray-500">Issued By</p>
              <p className="font-medium text-gray-800">{data.issuedBy}</p>
            </div> */}

              {/* <div>
              <p className="text-gray-500">Assigned To</p>
              <p className="font-medium text-gray-800">{data.assignedTo}</p>
            </div> */}
              {/* 
            <div>
              <p className="text-gray-500">Scheduled Start Date</p>
              <p className="font-medium text-gray-800">
                {data.scheduledStartDate}
              </p>
            </div>

            <div>
              <p className="text-gray-500">Reported On Date</p>
              <p className="font-medium text-gray-800">{data.reportedOn}</p>
            </div> */}

              <div>
                <p className="text-gray-500">Start Odometer Reading</p>
                <p className="font-medium text-gray-800">
                  {data.odometerReading + " / KM"}
                </p>
              </div>

              {data?.endingOdometer ? (
                <div>
                  <p className="text-gray-500">End Odometer Reading</p>
                  <p className="font-medium text-gray-800">
                    {data.endingOdometer + " / KM"}
                  </p>
                </div>
              ) : (
                <></>
              )}

              {/* <div>
              <p className="text-gray-500">Priority</p>
              <p className="font-medium text-gray-800">{data.priorityId}</p>
            </div> */}

              {!isEdit ? (
                <div>
                  <p className="text-gray-500">Work Order Type</p>
                  <div className="flex gap-2">
                    <p className="font-medium text-gray-800">
                      {data.workorderType}
                    </p>
                    {workorderType[workOrderDetail?.serviceType] !== "Wear And Tear" && <button
                      onClick={() => {
                        setIsEdit(true);
                      }}
                    >
                      <PencilIcon className="w-4 h-4 text-blue-700" />
                    </button>}
                  </div>
                </div>
              ) : (
                <div className="flex gap-2">
                  <select
                    value={workOrderTypesFilter}
                    onChange={(e) => setWorkOrderTypesFilter(e.target.value)}
                    className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Select WorkOrder Type</option>
                    {Object.entries(workorderTypeValues).map(([key, value]) => (
                      <option value={key}>{value}</option>
                    ))}
                  </select>
                  <button
                    onClick={() => {
                      handleSaveTheWorkOrder();
                    }}
                  >
                    Save
                  </button>{" "}
                  <button
                    onClick={() => {
                      setIsEdit(false);
                    }}
                  >
                    Cancel
                  </button>{" "}
                </div>
              )}

              {data?.status === "Service Completed" && (
                <div>
                  <p className="text-gray-500">Work Order Ageing</p>
                  <p className="font-medium text-gray-800">
                    {moment(data?.endDate).diff(
                      moment(data?.startDate),
                      "days",
                    ) + " Days"}
                  </p>
                </div>
              )}

              <div>
                <p className="text-gray-500">Block Start Date</p>
                <p className="font-medium text-gray-800">
                  {data.blockStartDate}
                </p>
              </div>

              <div>
                <p className="text-gray-500">Block End Date</p>
                <p className="font-medium text-gray-800">{data.blockEndDate}</p>
              </div>

              <div>
                <p className="text-gray-500">Blocked By</p>
                <p className="font-medium text-gray-800">{data.blockedBy}</p>
              </div>

              <div>
                <p className="text-gray-500">Created At</p>
                <p className="font-medium text-gray-800">{data.createdAt}</p>
              </div>

              <div>
                <p className="text-gray-500">Created By</p>
                <p className="font-medium text-gray-800">{data.createdBy}</p>
              </div>

              <div className="text-md font-semibold mb-6 bg-red-100 text-red-700 px-4 py-2 rounded-lg">
                <p className="text-gray-500">Billing Amount</p>
                <p className="font-medium text-gray-800">
                  {"₹ " + data.billingAmount}
                </p>
              </div>

              <div className="text-md font-semibold mb-6 bg-purple-100 text-purple-700 px-4 py-2 rounded-lg">
                <p className="text-gray-500">Cost To the Company</p>
                <p className="font-medium text-gray-800">
                  {"₹ " + data.costToCompany}
                </p>
              </div>

              {/* <div>
              <p className="text-gray-500">Issue Date</p>
              <p className="font-medium text-gray-800">{data.issueDate}</p>
            </div> */}

              {/* <div>
              <p className="text-gray-500">Expected Completion</p>
              <p className="font-medium text-gray-800">
                {data.expectedCompletion}
              </p>
            </div> */}
            </div>

            <div className="h-48 overflow-y-auto p-1 mt-4">
              <h1 className="text-lg font-semibold text-gray-800 mb-4">
                Extension Details
              </h1>

              {blockedVehicleExtensionData?.length > 0 ? (
                blockedVehicleExtensionData?.map((data) => (
                  <div
                    key={data?.id}
                    className="bg-gray-50 border rounded-lg p-4 mb-4"
                  >
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-500">Old End Date</p>
                        <h3 className="font-medium">
                          {formatDateAndTime(data?.oldEndDate)}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">New End Date</p>
                        <h3 className="font-medium">
                          {formatDateAndTime(data?.newEndDate)}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">Extended By</p>
                        <h3 className="font-medium">
                          {data?.extByName || "-"}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">Comment</p>
                        <h3 className="font-medium">{data?.reason || "-"}</h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500 mb-1">
                          Attachments
                        </p>
                        <div className="flex gap-2 flex-wrap">
                          {getAttachmentUrls(data?.attachments).map(
                            (url, index) => (
                              <img
                                key={index}
                                src={url}
                                alt={`attachment-${index}`}
                                onClick={() => handleImageOpen(url)}
                                className="w-20 h-20 rounded-lg border object-cover cursor-pointer"
                              />
                            ),
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 mt-10">
                  No Extension Details
                </p>
              )}
            </div>

            <div className="h-48 overflow-y-auto p-1 mt-4">
              <h1 className="text-lg font-semibold text-gray-800 mb-4">
                Tagged Vendors
              </h1>

              {taggedVendorDetails?.length > 0 ? (
                taggedVendorDetails?.map((row) => (
                  <div
                    key={data?.id}
                    className="bg-gray-50 border rounded-lg p-4 mb-4"
                  >
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-500">Vendor Name</p>
                        <h3 className="font-medium">{row.name || "-"}</h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">Vendor Type</p>
                        <h3 className="font-medium">
                          {vendorTypes[row.vendorType] || "-"}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">Contact Mobile</p>
                        <h3 className="font-medium">
                          {row.contactMobile || "-"}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500">
                          Is Credit Applied
                        </p>
                        <h3 className="font-medium">
                          {row.isCreditAllowed ? "True" : "False" || "-"}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500 mb-1">
                          Credit Amount
                        </p>
                        <h3 className="font-medium">
                          {row.creditAmount || "-"}
                        </h3>
                      </div>

                      <div>
                        <p className="text-sm text-gray-500 mb-1">
                          Credit Days
                        </p>
                        <h3 className="font-medium">{row.creditDays || "-"}</h3>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 mt-10">
                  No Vendor Details
                </p>
              )}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 flex flex-col gap-6">
            <div className="bg-white shadow-lg rounded-2xl p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Start Odometer Attachments
              </h3>

              <div className="grid grid-cols-2 sm:grid-cols-8 gap-4">
                {data?.odometerImages?.map((img, index) => (
                  <img
                    key={index}
                    src={img?.path || img?.url || img || img?.Location}
                    onClick={() => {
                      handleImageOpen(
                        img?.url || img?.Location || img?.image || img?.path,
                        index,
                        data?.odometerImages,
                      );
                    }}
                    alt="odometer"
                    className="w-16 h-16 object-cover rounded-lg border cursor-pointer"
                  />
                ))}
              </div>
            </div>

            {data?.endingOdometerImage && (
              <div className="bg-white shadow-lg rounded-2xl p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  End Odometer Attachments
                </h3>

                <div className="grid grid-cols-2 sm:grid-cols-8 gap-4">
                  {data?.endingOdometerImage?.map((img, index) => (
                    <img
                      key={index}
                      src={img?.path || img?.url || img || img?.Location}
                      onClick={() => {
                        handleImageOpen(
                          img?.url || img?.Location || img?.image || img?.path,
                          index,
                          data?.odometerImages,
                        );
                      }}
                      alt="odometer"
                      className="w-16 h-16 object-cover rounded-lg border cursor-pointer"
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Other Attachments */}
            <div className="bg-white shadow-lg rounded-2xl p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Other Attachments
              </h3>

              <div className="grid grid-cols-2 sm:grid-cols-8 gap-4">
                {data?.otherAttachments?.map((img, index) => (
                  <img
                    key={index}
                    src={img?.path || img?.url || img || img?.Location}
                    onClick={() => {
                      handleImageOpen(
                        img?.url || img?.Location || img?.image || img?.path,
                        index,
                        data?.otherAttachments,
                      );
                    }}
                    alt="attachment"
                    className="w-16 h-16 object-cover rounded-lg border cursor-pointer"
                  />
                ))}
              </div>
            </div>

            <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                Grand Total Summary
              </h2>

              <div className="w-full max-w-xl mx-auto text-sm">
                <div className="grid grid-cols-2 gap-2 py-1">
                  <div className="text-gray-600">Parts</div>
                  <div className="text-right font-medium">
                    ₹ {ccyFormat(partsAggregate.total)}
                  </div>

                  <div className="pl-4 text-gray-500">Parts - Cost</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(partsAggregate.unitPrice)}
                  </div>

                  <div className="pl-4 text-gray-500">Parts - Labour</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(partsAggregate.labor)}
                  </div>

                  <div className="pl-4 text-gray-500">Parts - Discount</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(partsAggregate.discount)}
                  </div>

                  <div className="pl-4 text-gray-500">Parts - Tax</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(partsAggregate.tax)}
                  </div>

                  <div className="text-gray-600">Tasks</div>
                  <div className="text-right font-medium">
                    ₹ {ccyFormat(tasksAggregate.total)}
                  </div>

                  <div className="pl-4 text-gray-500">Tasks - Cost</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(tasksAggregate.totalCost)}
                  </div>

                  <div className="pl-4 text-gray-500">Tasks - Labour</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(tasksAggregate.labor)}
                  </div>

                  <div className="pl-4 text-gray-500">Tasks - Discount</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(tasksAggregate.discount)}
                  </div>

                  <div className="pl-4 text-gray-500">Tasks - Tax</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(tasksAggregate.tax)}
                  </div>

                  <div className="text-gray-600">Labour Charges</div>
                  <div className="text-right font-medium">
                    ₹ {ccyFormat(labourAggregate.total)}
                  </div>

                  <div className="pl-4 text-gray-500">
                    Labour - Service Amount
                  </div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(labourAggregate.labor)}
                  </div>

                  <div className="pl-4 text-gray-500">Labour - Discount</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(labourAggregate.discount)}
                  </div>

                  <div className="pl-4 text-gray-500">Labour - Tax</div>
                  <div className="text-right text-gray-500">
                    ₹ {ccyFormat(labourAggregate.tax)}
                  </div>

                  <div className="col-span-2 border-t mt-2"></div>

                  {/* <div className="text-gray-800 font-semibold text-right">
                  Total
                </div>
                <div className="text-right font-semibold">
                  ₹ {ccyFormat(combinedTotal)}
                </div>

                <div className="text-gray-800 text-right">Rounding</div>
                <div className="text-right">
                  ₹ {ccyFormat(roundingAdjustment)}
                </div> */}

                  <div className="text-gray-800 font-semibold text-right">
                    G.Total
                  </div>
                  <div className="text-right font-semibold">
                    ₹ {ccyFormat(combinedTotal)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {paymentDetails?.length > 0 && (
            <div className="col-span-12 bg-white shadow-lg rounded-2xl p-6 mt-4 overflow-x-auto">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Payment Details
              </h2>

              <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Payment Amount
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Payment Mode
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Payment Type
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Transaction Id
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Payment Date
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Attachments
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                      Created At
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paymentDetails.map((payment, paymentIndex) => (
                    <tr key={paymentIndex} className="border-b">
                      <td className="px-4 py-3">
                        {payment?.paymentAmount || "-"}
                      </td>

                      <td className="px-4 py-3">
                        {payment?.paymentMode || "-"}
                      </td>

                      <td className="px-4 py-3">
                        {payment?.paymentType || "-"}
                      </td>

                      <td className="px-4 py-3">
                        {payment?.transactionId || "-"}
                      </td>

                      <td className="px-4 py-3">
                        {formatDate(payment?.dateOfPayment) || "-"}
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex gap-3 flex-wrap">
                          {payment?.attachments &&
                            JSON.parse(payment?.attachments)?.map(
                              (file, index) => {
                                const url =
                                  file?.url ||
                                  file?.path ||
                                  file?.Location ||
                                  file;

                                const type = getFileType(url);

                                return (
                                  <div
                                    key={index}
                                    className="w-20 h-20 flex items-center justify-center border rounded-lg overflow-hidden bg-gray-50 cursor-pointer"
                                  >
                                    {type === "image" && (
                                      <img
                                        src={url}
                                        alt={`Attachment ${index + 1}`}
                                        onClick={() => {
                                          handleImageOpen(
                                            url,
                                            index,
                                            JSON.parse(payment?.attachments),
                                          );
                                        }}
                                        className="w-full h-full object-cover"
                                      />
                                    )}

                                    {type === "video" && (
                                      <video className="w-full h-full object-cover">
                                        <source src={url} />
                                      </video>
                                    )}

                                    {type === "pdf" && (
                                      <span className="text-red-500 font-semibold">
                                        PDF
                                      </span>
                                    )}

                                    {type === "doc" && (
                                      <span className="text-blue-500 font-semibold">
                                        DOC
                                      </span>
                                    )}

                                    {type === "other" && (
                                      <span className="text-gray-500 text-xs">
                                        FILE
                                      </span>
                                    )}
                                  </div>
                                );
                              },
                            )}
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        {formatDateAndTime(payment?.createdAt) || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Service Part Items
            </h2>

            <div className="w-full overflow-x-auto">
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "none",
                  overflowX: "auto",
                }}
              >
                <Table
                  sx={{
                    minWidth: 1800,
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Part Name</TableCell>
                      <TableCell>Part Number</TableCell>
                      <TableCell>Action On Part</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Unit Price</TableCell>
                      <TableCell>Warranty Expiry Date</TableCell>
                      <TableCell>Attachment</TableCell>
                      <TableCell align="right">Labor Cost</TableCell>
                      <TableCell align="right">Discount Amount</TableCell>
                      <TableCell align="right">Discount Percentage</TableCell>
                      <TableCell align="right">CGST Percentage</TableCell>
                      <TableCell align="right">SGST Percentage</TableCell>
                      <TableCell align="right">Total Tax Percentage</TableCell>
                      <TableCell align="right">Total Tax</TableCell>
                      <TableCell align="right">Total</TableCell>
                      <TableCell align="right">Edit</TableCell>
                      <TableCell align="right">Delete</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vehicleServicePartDetails?.length > 0 ? (
                      vehicleServicePartDetails?.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.partName || "-"}</TableCell>
                          <TableCell>{row.partNumber || "-"}</TableCell>
                          <TableCell>{row.actionOnPart || "-"}</TableCell>
                          <TableCell>{row.quantity || "-"}</TableCell>
                          <TableCell>{row.unitPrice || "-"}</TableCell>
                          <TableCell>{row.warrantyExpiryDate || "-"}</TableCell>

                          <TableCell>
                            {parseImages(row?.attachments)?.length > 0 ? (
                              <div className="grid grid-cols-4 gap-2">
                                {parseImages(row?.attachments).map(
                                  (file, index) => {
                                    const url =
                                      file?.path ||
                                      file?.url ||
                                      file?.Location ||
                                      file;

                                    const type = getFileType(url);

                                    return (
                                      <div
                                        key={index}
                                        className="w-10 h-10 flex items-center justify-center border rounded-lg overflow-hidden cursor-pointer bg-gray-50"
                                        onClick={() => handleImageOpen(url)}
                                      >
                                        {type === "image" && (
                                          <img
                                            src={url}
                                            alt="attachment"
                                            className="w-full h-full object-cover"
                                          />
                                        )}

                                        {type === "video" && (
                                          <video className="w-full h-full object-cover">
                                            <source src={url} />
                                          </video>
                                        )}

                                        {type === "pdf" && (
                                          <span className="text-xs text-red-500 font-semibold">
                                            PDF
                                          </span>
                                        )}

                                        {type === "doc" && (
                                          <span className="text-xs text-blue-500 font-semibold">
                                            DOC
                                          </span>
                                        )}

                                        {type === "other" && (
                                          <span className="text-xs text-gray-500">
                                            FILE
                                          </span>
                                        )}
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.laborCost)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.discountAmount)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.discountPercentage)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.cgstPercentage)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.sgstPercentage)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.totalTaxPercentage)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.totalTax)}
                          </TableCell>

                          <TableCell align="right">
                            {ccyFormat(row.totalCost)}
                          </TableCell>

                          {validation ? null : (
                            <TableCell align="right">
                              <button
                                type="button"
                                title="Edit"
                                onClick={() => {
                                  setCreationType({
                                    type: "edit",
                                    id: row.id,
                                  });

                                  setActiveTab("parts");

                                  setPartService([
                                    {
                                      partName: row?.partName,
                                      partNumber: row?.partNumber,
                                      actionOnPart: row?.actionOnPart,
                                      quantity: row?.quantity,
                                      unitPrice: row?.unitPrice,
                                      laborCost: row?.laborCost,
                                      totalCost: row?.totalCost,
                                      cgstPercentage: row?.cgstPercentage,
                                      sgstPercentage: row?.sgstPercentage,
                                      totalTaxPercentage:
                                        row?.totalTaxPercentage,
                                      totalTaxAmount: row?.totalTaxAmount,
                                      discountPercentage:
                                        row?.discountPercentage,
                                      discountAmount: row?.discountAmount,
                                      warrantyExpiryDate:
                                        row?.warrantyExpiryDate,
                                      attachments:
                                        JSON.parse(row.attachments) || [],
                                    },
                                  ]);
                                }}
                                className="text-green-500 hover:text-green-700"
                              >
                                <Pencil size={24} />
                              </button>
                            </TableCell>
                          )}

                          {validation ? null : (
                            <TableCell align="right">
                              <button
                                type="button"
                                title="Delete"
                                className="text-red-500 hover:text-red-700"
                                onClick={() => {
                                  setConfirmModal(true);
                                  setDeleteId({
                                    id: row?.id,
                                    type: "parts",
                                  });
                                }}
                              >
                                <Trash size={24} />
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={14}
                          align="center"
                          sx={{
                            fontWeight: "bold",
                            py: 4,
                            color: "text.secondary",
                          }}
                        >
                          No Part Details Added
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Service Task Items
            </h2>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700, borderRadius: 10 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Task Description</TableCell>
                    <TableCell>Panel Details</TableCell>
                    <TableCell>Attachment</TableCell>
                    <TableCell align="right">Cost</TableCell>
                    <TableCell align="right">Labor Cost</TableCell>
                    <TableCell align="right">Discount Amount</TableCell>
                    <TableCell align="right">Discount Percentage</TableCell>
                    <TableCell align="right">CGST Percentage</TableCell>
                    <TableCell align="right">SGST Percentage</TableCell>
                    <TableCell align="right">Total Tax Percentage</TableCell>
                    <TableCell align="right">Total Tax</TableCell>
                    <TableCell align="right">Total</TableCell>
                    <TableCell align="right">Edit</TableCell>
                    <TableCell align="right">Delete</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {vehicleTaskDetails.length > 0 ? (
                    vehicleTaskDetails?.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.taskDescription || "-"}</TableCell>
                        <TableCell>{row.panelDetails || "-"}</TableCell>
                        <TableCell>
                          {parseImages(row?.attachments)?.length > 0 ? (
                            <div className="grid grid-cols-4 gap-2">
                              {parseImages(row?.attachments).map(
                                (file, index) => {
                                  const url =
                                    file?.path ||
                                    file?.url ||
                                    file?.Location ||
                                    file;

                                  const type = getFileType(url);

                                  return (
                                    <div
                                      key={index}
                                      className="w-10 h-10 flex items-center justify-center border rounded-lg overflow-hidden cursor-pointer bg-gray-50"
                                      onClick={() => handleImageOpen(url)}
                                    >
                                      {type === "image" && (
                                        <img
                                          src={url}
                                          alt="attachment"
                                          className="w-full h-full object-cover"
                                        />
                                      )}

                                      {type === "video" && (
                                        <video className="w-full h-full object-cover">
                                          <source src={url} />
                                        </video>
                                      )}

                                      {type === "pdf" && (
                                        <span className="text-xs text-red-500 font-semibold">
                                          PDF
                                        </span>
                                      )}

                                      {type === "doc" && (
                                        <span className="text-xs text-blue-500 font-semibold">
                                          DOC
                                        </span>
                                      )}

                                      {type === "other" && (
                                        <span className="text-xs text-gray-500">
                                          FILE
                                        </span>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.totalCost - row.totalTax)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.laborCost)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.discountAmount)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.discountPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.csgtPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.sgstPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.totalTaxPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.totalTax)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(Number(row.totalCost))}
                        </TableCell>
                        {validation ? (
                          <></>
                        ) : (
                          <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              onClick={() => {
                                setCreationType({ type: "edit", id: row.id });
                                setActiveTab("vehicleservicetasks");
                                setTasks([
                                  {
                                    description: row.taskDescription || "",
                                    panelDetails: row.panelDetails || "",
                                    attachements:
                                      JSON.parse(row.attachments) || [],
                                    cost: row.totalCost || "",
                                    discountPercentage: row?.discountPercentage,
                                    discountAmount: row?.discountAmount,
                                    csgtPercentage: row?.csgtPercentage,
                                    sgstPercentage: row?.sgstPercentage,
                                    totalTaxPercentage: row?.totalTaxPercentage,
                                    laborCost: row.laborCost || "",
                                  },
                                ]);
                              }}
                              className="text-green-500 hover:text-green-700"
                            >
                              <Pencil size={24} />
                            </button>
                          </TableCell>
                        )}
                        {validation ? (
                          <></>
                        ) : (
                          <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              className="text-green-500 hover:text-green-700"
                              onClick={() => {
                                setConfirmModal(true);
                                setDeleteId({ id: row?.id, type: "tasks" });
                              }}
                            >
                              <Trash size={24} className="text-red-300" />
                            </button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={13}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          py: 4,
                          color: "text.secondary",
                        }}
                      >
                        No Task Details Added
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Service Labour Charges
            </h2>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700, borderRadius: 10 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Labor Count</TableCell>
                    <TableCell>Service Amount</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Discount Amount</TableCell>
                    <TableCell align="right">Discount Percentage</TableCell>
                    <TableCell>CGST Percentage</TableCell>
                    <TableCell align="right">SGST Percentage</TableCell>
                    <TableCell align="right">Total Tax Percentage</TableCell>
                    <TableCell align="right">Total Tax Amount</TableCell>
                    <TableCell align="right">Total Amount</TableCell>
                    <TableCell align="right">Edit</TableCell>
                    <TableCell align="right">Delete</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {serviceLabourCost.length > 0 ? (
                    serviceLabourCost?.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.labourCount || "-"}</TableCell>
                        <TableCell>{row.serviceAmount || "-"}</TableCell>
                        <TableCell>{row.description || "-"}</TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.discountAmount)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.discountPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.cgstPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.sgstPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row.totalTaxPercentage)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row?.totalTaxAmount)}
                        </TableCell>
                        <TableCell align="right">
                          {ccyFormat(row?.totalAmount)}
                        </TableCell>
                        {validation ? (
                          <></>
                        ) : (
                          <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              onClick={() => {
                                setCreationType({ type: "edit", id: row.id });
                                setActiveTab("vehicleservicelaborCost");
                                setLabours([
                                  {
                                    laborCount: row.labourCount || "",
                                    serviceAmount: row?.serviceAmount || "",
                                    description: row?.description || "",
                                    cgstPercentage: row?.cgstPercentage || "",
                                    sgstPercentage: row?.sgstPercentage || "",
                                    totalTaxPercentage:
                                      row?.totalTaxPercentage || "",
                                      discountPercentage: row?.discountPercentage,
                                    discountAmount: row?.discountAmount,
                                    totalTaxAmount: row?.totalTaxAmount || "",
                                    totalTaxAmount: row?.totalTaxAmount,
                                    // attachements:
                                    //   JSON.parse(row?.attachments) || [],
                                  },
                                ]);
                              }}
                              className="text-green-500 hover:text-green-700"
                            >
                              <Pencil size={24} />
                            </button>
                          </TableCell>
                        )}
                        {validation ? (
                          <></>
                        ) : (
                          <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              className="text-green-500 hover:text-green-700"
                              onClick={() => {
                                setConfirmModal(true);
                                setDeleteId({ id: row?.id, type: "labour" });
                              }}
                            >
                              <Trash size={24} className="text-red-300" />
                            </button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          py: 4,
                          color: "text.secondary",
                        }}
                      >
                        No Task Details Added
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Tagged Bookings
            </h2>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700, borderRadius: 10 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Booking ID</TableCell>
                    <TableCell>Customer Name</TableCell>
                    <TableCell>Customer Email</TableCell>
                    <TableCell>Customer Mobile</TableCell>
                    <TableCell align="right">
                      Damage Charges Collected
                    </TableCell>
                    <TableCell align="right">
                      Downtime Charges Collected
                    </TableCell>
                    <TableCell align="right">Attachments</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {taggedBookings.length > 0 ? (
                    taggedBookings?.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.bookingCode || "-"}</TableCell>
                        <TableCell>{row.customerName || "-"}</TableCell>
                        <TableCell>{row.customerEmail || "-"}</TableCell>
                        <TableCell>{row.customerMobile || "-"}</TableCell>
                        <TableCell>
                          {row.damageChargesCollected || "-"}
                        </TableCell>
                        <TableCell>
                          {row.downtimeChargesCollected || "-"}
                        </TableCell>
                        <TableCell>
                          {parseImages(row?.attachments)?.length > 0 ? (
                            <div className="grid grid-cols-2 gap-1">
                              {parseImages(row?.attachments).map(
                                (img, index) => (
                                  <img
                                    key={index}
                                    src={
                                      img?.path ||
                                      img?.url ||
                                      img ||
                                      img?.Location
                                    }
                                    onClick={() => {
                                      handleImageOpen(
                                        img?.url ||
                                          img?.Location ||
                                          img?.image ||
                                          img?.path,
                                      );
                                    }}
                                    alt="attachment"
                                    className="w-8 h-8 object-cover rounded-lg border cursor-pointer"
                                  />
                                ),
                              )}
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={13}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          py: 4,
                          color: "text.secondary",
                        }}
                      >
                        No Tagged Bookings Added
                      </TableCell>
                    </TableRow>
                  )}

                  {/* <TableRow>
                  <TableCell
                    colSpan={4}
                    align="right"
                    sx={{ fontWeight: "bold" }}
                  >
                    Grand Total
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    {ccyFormat(grandTotalForTasks)}
                  </TableCell>
                </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkOrderSummary;
